module.exports = __webpack_public_path__ + "media/02a_ASANBUDAPEST-BEATS05.996d7862.mp3";